import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Pranshu Tomer',
    title: "Full Stack Developer | MERN & Java Backend",
    desciption:"The screen was blank, but that wasn’t the problem — it was the silence before creation. Every idea starts quiet, until the first line of code brings it to life.",
    image: './profile_photo.jpg',
    resumePdf: resume
}
